import React from 'react'
import ProductContent from './ProductContent'
import PromoContent from './PromoContent'
import DefaultContent from './DefaultContent'
import CategoryContent from './CategoryContent'

const TargeterContainer = ({ containerObject, templateName, contentId, dataZone }) => {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row`} >
            {containerObject && containerObject.targeterResult ?
                <div id="optionalTargetter" className='d-block mt-2'>
                    {containerObject && containerObject.attributes && containerObject.attributes.targeterContentType == "product" ?
                        <ProductContent containerObject={containerObject ? containerObject : ""}/>
                        :
                        containerObject && containerObject.attributes && containerObject.attributes.targeterContentType == "promo" ?
                            <PromoContent containerObject={containerObject ? containerObject : ""}/>
                            :
                            containerObject && containerObject.attributes && containerObject.attributes.targeterContentType == "category" ?
                            <CategoryContent containerObject={containerObject ? containerObject : ""}/>
                            :
                            <DefaultContent containerObject={containerObject ? containerObject : ""}/> }
                </div> : ""}
        </div>
    )
}

export default TargeterContainer